export default function buildUrl(url, urlVars) {
    return url.replace(/:(\w*)/g, (match, variable) => urlVars[variable]);
}
